import {styled} from "@mui/material/styles";
import Typography from "@mui/material/Typography";

export const Title=styled(Typography)(()=>({
    marginBottom: '20px',
    marginLeft: '5px',
    display: 'inline-block',
}));